module.exports = __webpack_public_path__ + "static/app-editor-mike-1bc730f90f01f19551cd13492a249792.png";